import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { ContactMessage } from '@models';

@Injectable({ providedIn: 'root' })
export class ContactMessageService extends CrudService<ContactMessage> {
  constructor() {
    super('contact-messages', ContactMessage);
  }
}

